import { z } from "zod";

import { DiscountTierDtoSchema } from "./discount-tiers";
import { OfferProductDtoSchema } from "./offer-products";
import {
  DiscountApplicationMethodList,
  DiscountApplicationTypeList,
  DiscountDiscountTypeList,
  DiscountUnitTypeList,
} from "./offers";

export const DiscountDtoSchema = z.object({
  id: z.string().uuid().optional(),
  enabled: z.boolean().default(false),
  isTest: z.boolean().default(false),
  isArchived: z.boolean().default(false),
  name: z.string(),
  offerProducts: OfferProductDtoSchema.array().optional().default([]),

  unitType: z.enum(DiscountUnitTypeList).default("dollar"),
  discountType: z.enum(DiscountDiscountTypeList).default("dollar"),
  tiers: DiscountTierDtoSchema.array().default([]),
  maximumDollarDiscount: z.number().nullish(),
  discountApplicationType: z.enum(DiscountApplicationTypeList),
  discountApplicationMethod: z.enum(DiscountApplicationMethodList),
  shouldStack: z.boolean(),
  shouldRejectCodes: z.boolean(),
});

export type DiscountDto = z.infer<typeof DiscountDtoSchema>;
